import { createFileRoute } from '@tanstack/react-router';
import { AdminOrgsPage } from '../../features/tenancy';

export const Route = createFileRoute('/admin/orgs/')({ component: AdminOrgsPage });
